import { AppAnalytics, ButtonClicked } from '../../Analytics';
import { BUTTON_NAME, PAGE_NAME } from '../../eventNames';

const buttonClickEvents = {
  storyPlayButton: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.STORY_PLAY_BUTTON, context));
  },
  closeListView: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.CLOSE_LIST_VIEW, context));
  },
  closeStoryView: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.CLOSE_STORY_VIEW, context));
  },
  goToReportListView: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.GO_TO_REPORT_LIST_VIEW, context));
  },
  moveNextStoryCard: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.NEXT_STORY_CARD, context));
  },
  movePrevStoryCard: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.PREV_STORY_CARD, context));
  },
  consultDoctor: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.CONSULT_DOCTOR, context));
  },
  downloadPDF: (eventContext, referrer, pagename) => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.DOWNLOAD_PDF, context, referrer, pagename)
    );
  },
  shareAssessment: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.SHARE_ASSESSMENT, context));
  },
  bannerPress: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.BANNER_PRESS, context));
  },
  ayushmanCta: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.AYUSHMAN_CTA, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  consultNowCta: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.CONSULT_NOW_CTA, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  careProgramCta: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.CARE_PROGRAM_CTA, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  horizontalScroll: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.HORIZONTAL_SCROLL, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  disclaimerReadMore: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.DISCLAIMER_READ_MORE, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  disclaimerLinkToRef: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(
        BUTTON_NAME.DISCLAIMER_LINK_TO_REF,
        context,
        null,
        PAGE_NAME.REPORT_LIST_VIEW
      )
    );
  },
  advicesButton: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.ADVICES_BUTTON, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  expertRecomButton: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.EXPERT_RECOM_BUTTON, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  productViewDetails: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.PRODUCT_VIEW_DETAILS, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  productBuyNow: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.PRODUCT_BUY_NOW, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  openChat: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.OPEN_CHAT_BTN, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  viewPrescription: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(
        BUTTON_NAME.VIEW_PRESCRIPTION_CTA,
        context,
        null,
        PAGE_NAME.REPORT_LIST_VIEW
      )
    );
  },
  orderMedicine: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.ORDER_MEDICINE_BTN, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  bookLabTest: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.BOOK_LAB_TEST_BTN, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  shareAssessmentToPlatForm: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.SHARE_ASSESSMENT_TO_A_PLATFORM, context)
    );
  },
  shareItemPress: buttonName => {
    const context = {};
    AppAnalytics.reportEvent(new ButtonClicked(buttonName, context));
  },
  playVideo: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.PLAY_VIDEO, context));
  },
  pauseVideo: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.PAUSE_VIDEO, context));
  },
  forwardVideo: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.FORWARD_VIDEO, context));
  },
  backwardVideo: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.BACKWARD_VIDEO, context));
  },
  muteVideo: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.MUTE_VIDEO, context));
  },
  unMuteVideo: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.UNMUTE_VIDEO, context));
  },

  toggleVideoControls: eventContext => {
    const { showVideoControls } = eventContext;
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(
        showVideoControls ? BUTTON_NAME.SHOW_VIDEO_CONTROLS : BUTTON_NAME.HIDE_VIDEO_CONTROLS,
        context
      )
    );
  },

  downloadAPP: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.DOWNLOAD_APP, context));
  },
  footerPress: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.FOOTER_PRESS, context));
  },
  modeSelectionForReportsCommunication: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.REPORT_COMMUNICATION_MODE_SELECTION, context)
    );
  },
  sendAssessmentCommunication: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.SEND_ASSESSMENT_REPORTS, context));
  },
  closeReportPopup: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.CLOSE_SEND_REPORT_POPUP, context));
  },
  closeReportSendOnSuccessPopup: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.CLOSE_SUCCESS_ON_GET_REPORT_POPUP, context)
    );
  },
  closeReportSendOnErrorPopup: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.CLOSE_ERROR_ON_GET_REPORT_POPUP, context)
    );
  },
  coachMarkVisibility: eventContext => {
    const { shown = true } = eventContext;
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(
        shown ? BUTTON_NAME.COACH_MARK_VIEWED : BUTTON_NAME.COACH_MARK_CLOSED,
        context
      )
    );
  },
  loginSignupSuccess: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.LOGIN_SIGNUP_SUCCESS, context));
  },
  closeLoginSignup: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.CLOSE_LOGIN_SIGNUP, context));
  },
  downloadPdfFromTinyUrl: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.DOWNLOAD_PDF_FROM_TINY_URL_LANDING_PAGE, context)
    );
  },
  submitCSTPopup: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.CST_SUBMISSION_SUCCESS, context));
  },
  closeCSTPopup: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.CST_POP_UP_CLOSED, context));
  },
  chatPillSelectionCST: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.CSAT_CHAT_PILL, context));
  },
  startAssessment: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.START_ASSESSMENT, context));
  },
  tabChange: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.TAB_CHANGE, context));
  },
  videoProgressTabChange: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.VIDEO_PROGRESS_TAB_CHANGE, context));
  },
  lockButton: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.LOCK_BUTTON, context));
  },
  dailyReminderToggle: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new ButtonClicked(BUTTON_NAME.DAILY_REMINDER_TOGGLE, context));
  },
  diagnosisViewDetails: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(
        BUTTON_NAME.DIAGNOSIS_VIEW_DETAILS,
        context,
        null,
        PAGE_NAME.REPORT_LIST_VIEW
      )
    );
  },
  packageKnowMore: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.PACKAGE_KNOW_MORE, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
  productKitKnowMore: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(
        BUTTON_NAME.PRODUCT_KIT_KNOW_MORE,
        context,
        null,
        PAGE_NAME.REPORT_LIST_VIEW
      )
    );
  },
  bookFreeConsultation: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(
        BUTTON_NAME.BOOK_FREE_CONSULTATION,
        context,
        null,
        PAGE_NAME.REPORT_LIST_VIEW
      )
    );
  },
  bookVideoConsultation: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(
        BUTTON_NAME.BOOK_VIDEO_CONSULTATION,
        context,
        null,
        PAGE_NAME.REPORT_LIST_VIEW
      )
    );
  },
  closeModal: eventContext => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ButtonClicked(BUTTON_NAME.CLOSE_MODAL, context, null, PAGE_NAME.REPORT_LIST_VIEW)
    );
  },
};

export default buttonClickEvents;
